class Author {
	constructor() {
		this.authorProfileImgContainer = document.querySelector( '#author-profile-img span' );
		this.authorFirstNameText = document.querySelector( '#author-firstname' )?.textContent ?? '';
		this.authorLastNameText = document.querySelector( '#author-lastname' )?.textContent ?? '';

		this.init();
	}

	init() {
		if ( ! this.authorProfileImgContainer ) {
			return null;
		}

		let initials = this.authorFirstNameText.charAt( 0 ) + this.authorLastNameText.charAt( 0 );
		initials = initials ? initials : 'A';

		// Set the text.
		this.authorProfileImgContainer.textContent = initials;
	}
}

new Author();
